module.exports = __webpack_public_path__ + "static/media/216-Uebergabe_ID_19.72bb100f.mp3";